import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react';
import settings from '../../config/settings';

export interface ApiProject {
    project_id: string;
    name: string;
}

interface HoleArg {
    projectId: string;
    holeId: string;
}

export const drillholeApi = createApi({
    reducerPath: 'drillholeApi',
    baseQuery: fetchBaseQuery({
        baseUrl: settings.drillholeApiUrl,
    }),
    tagTypes: ['Projects'],
    endpoints: (builder) => ({
        getProjects: builder.query<ApiProject[], void>({
            query: () => '/projects',
            providesTags: ['Projects'],
        }),
        renameProject: builder.mutation<ApiProject, {projectId: string; name: string}>({
            query: ({projectId, name}) => ({
                url: `/projects/${projectId}/rename`,
                method: 'POST',
                body: {name},
            }),
            invalidatesTags: ['Projects'],
        }),
        getDrillholes: builder.query<any[], string>({
            query: (projectId) => `/projects/${projectId}/drillholes`,
        }),
        getDrillholeById: builder.query<any, HoleArg>({
            query: ({projectId, holeId}) => `/projects/${projectId}/drillholes/${holeId}`,
        }),
        getDrillholeMinerals: builder.query<any, HoleArg>({
            query: ({projectId, holeId}) => `/projects/${projectId}/drillholes/${holeId}/minerals`,
        }),
        getDrillholeXrf: builder.query<any, HoleArg>({
            query: ({projectId, holeId}) => `/projects/${projectId}/drillholes/${holeId}/xrf`,
        }),
    }),
});

export const {
    useGetProjectsQuery,
    useRenameProjectMutation,
    useGetDrillholesQuery,
    useLazyGetDrillholeByIdQuery,
    useLazyGetDrillholeMineralsQuery,
    useLazyGetDrillholeXrfQuery,
} = drillholeApi;
